// Prototype cleanup: this temporary image-ranking demo route should be removed
// when the hosted ranking prototype is retired or replaced by product UI.
export const ADMIN_IMAGE_RANKING_PATH = "/admin/image-ranking";
export const IMAGE_RANKING_CODEX_PATH = "/image-ranking-codex";
export const IMAGE_RANKING_DEMO_PATH = "/image-ranking-demo";

export function isImageRankingDemoRouteEnabled(mode: string, flag: string | undefined) {
  return mode === "staging" && flag === "true";
}
